module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.dataRequiredLoaded) ? _c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('titulo-secao', {
    staticClass: "bg-warning text-black"
  }, [_c('strong', [_vm._v("Vistoria (GGV)")]), _c('br'), _vm._v("\n            Confira os equipamentos/acessórios e as fotos no momento da guarda deste veículo\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao salvar a vistoria, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Vistoria (GGV) salva com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default wrapper-sm m-b"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.numero))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Apreensão")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.extraModel.dataApreensao) + " " + _vm._s(_vm.extraModel.horaApreensao))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Placa Original")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.placaOriginal || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Placa Ostentada")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.placa || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.chassi || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Marca")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.marca || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.modelo || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cor")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.cor || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.renavam || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.ano || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6 m-b-sm"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número do Motor")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.grv.numeroMotor || '-'))])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Equipamentos / Acessórios da Vistoria")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.dataRequired.equipamentos), function(equip) {
    return _c('div', {
      key: equip.id,
      staticClass: "form-group b-b padder-v"
    }, [_c('div', {
      staticClass: "col-sm-offset-2 col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'ggv-equip-' + equip.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(equip.checked) ? _vm._i(equip.checked, null) > -1 : (equip.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = equip.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(equip, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(equip, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(equip, "checked", $$c)
          }
        }, function($event) {
          return _vm.marcaEquipamento($event, equip)
        }]
      }
    }), _c('i')]), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'ggv-equip-' + equip.id
      }
    }, [_vm._v(_vm._s(equip.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('btn-check-possui', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      model: {
        value: (equip.possui),
        callback: function($$v) {
          _vm.$set(equip, "possui", $$v)
        },
        expression: "equip.possui"
      }
    })], 1)])])])
  }), 0)]), _vm._v(" "), _c('titulo-secao', [_vm._v("Fotos da Vistoria")]), _vm._v(" "), _c('arquivos-grv', {
    attrs: {
      "arquivos": _vm.arquivosGgv,
      "tipos-arquivo": _vm.dataRequired.tipoArquivo,
      "origem": "ggv"
    }
  }), _vm._v(" "), _c('titulo-secao', [_vm._v("Parecer Final")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md m-b-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Em conformidade com a GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.conforme),
      expression: "conforme"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.conforme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Conforme")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não conforme")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg"
  }, [_vm._v(_vm._s(_vm.ggvJaExiste ? 'Atualizar Vistoria (GGV)' : 'Confirmar GGV'))]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                        * a confirmação inclui imediatamente este bem no pátio e transmite as informações para o DETRO\n                      ")])])])])], 1)])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a10b3a30","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/Ggv.vue
// module id = 2017
// module chunks = 18